<template>
  <div class="view-131">
    <view652 />
    <view662 />
    <div class="view-132">
      <div class="view-134">
        <div class="text-195 fontawesome5free-solid-normal-black-20px"></div>
        <div class="text-196 poppins-semi-bold-black-20px">Тесты</div>
        <div class="task">
          <img
            class="vector-126"
            src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-579.svg"
            alt="Vector"
          />
          <img
            class="vector-127"
            src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-580.svg"
            alt="Vector"
          />
          <img
            class="vector-128"
            src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-581.svg"
            alt="Vector"
          />
          <img
            class="vector-129"
            src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-582.svg"
            alt="Vector"
          />
          <img
            class="vector-130"
            src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-583.svg"
            alt="Vector"
          />
          <img
            class="vector-131"
            src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-584.svg"
            alt="Vector"
          />
        </div>
      </div>
    </div>
    <view672 :drawingProps="view67Props.drawingProps" />
  </div>
</template>

<script>
import View652 from "./View652";
import View662 from "./View662";
import View672 from "./View672";
export default {
  name: "View642",
  components: {
    View652,
    View662,
    View672,
  },
  props: ["view67Props"],
};
</script>

<style>
.view-131,
.view-135 {
  align-items: flex-start;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  gap: 20px;
  left: 0;
  min-height: 233px;
  padding: 13px 21px;
  position: absolute;
  top: 60px;
  width: 350px;
}

.view-132,
.view-136 {
  align-items: center;
  display: flex;
  width: 125px;
}

.view-134,
.view-137 {
  height: 30px;
  position: relative;
  width: 129px;
}

.text-195,
.text-208 {
  left: 115px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 10px);
  white-space: nowrap;
}

.text-196,
.text-209 {
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}

.task,
.task-1 {
  aspect-ratio: 1.06;
  height: 78.7%;
  left: 0;
  position: absolute;
  top: 10%;
  width: 19.38%;
}

.vector-126,
.vector-132 {
  height: 12.71%;
  left: 38.45%;
  position: absolute;
  top: 87.77%;
  width: 67.55%;
}

.vector-127,
.vector-133 {
  height: 12.71%;
  left: 38.45%;
  position: absolute;
  top: 46.59%;
  width: 67.55%;
}

.vector-128,
.vector-134 {
  height: 12.71%;
  left: 38.45%;
  position: absolute;
  top: 5.41%;
  width: 67.55%;
}

.vector-129,
.vector-135 {
  height: 30.35%;
  left: -6%;
  position: absolute;
  top: -6.35%;
  width: 34.22%;
}

.vector-130,
.vector-136 {
  height: 30.35%;
  left: -6%;
  position: absolute;
  top: 34.83%;
  width: 34.22%;
}

.vector-131,
.vector-137 {
  height: 30.35%;
  left: -6%;
  position: absolute;
  top: 76%;
  width: 34.22%;
}
</style>
